import React from 'react';
import PropTypes from 'prop-types';
import { SovosReadOnlySlidingPanel } from 's1-ui/sovos-sliding-panel';
import SovosButtonsGroup from 's1-ui/sovos-buttons-group/SovosButtonsGroup';
import SovosRaisedButton from 's1-ui/sovos-raised-button/SovosRaisedButton';
import FilterItem from 'shared/components/filterItem/FilterItem';
import { white, purpleDecorations } from 'theme/mainColors';
import { DATE, STRING, NUMBER } from 'shared/constants/InvoiceFiltersTypes';
import './invoiceFilterSlidingPanel.scss';

class InvoiceFilterSlidingPanel extends React.Component {
  state = {
    disableApplyButton: true
  };

  handleCloseSlidingPanel = () => {
    this.setState({ disableApplyButton: true });
    this.props.invoiceFiltersActions.restoreInvoiceFilters();
    this.props.onClose();
  };

  handleApplyClick = () => {
    this.setState({ disableApplyButton: true });
    this.props.invoiceFiltersActions.applyFilters();
    this.props.onClose();
  };

  handleClearClick = () => {
    this.setState({ disableApplyButton: false });
    this.props.invoiceFiltersActions.clearAllInvoiceFilters();
  };

  handleExpandClick = filter =>
    this.props.invoiceFiltersActions.expandInvoiceFilter(filter);

  handleCollapseClick = filter => {
    if (filter.data.type !== NUMBER) {
      if (filter.data.value !== '') {
        this.setState({ disableApplyButton: false });
      }
    } else {
      if (filter.data.min.value !== '' || filter.data.max.value !== '') {
        this.setState({ disableApplyButton: false });
      }
    }
    this.props.invoiceFiltersActions.clearInvoiceFilter(filter);
  };

  handleFieldChange = (ev, value, filter) => {
    if (filter.data.type === DATE) {
      const filterKey = filter.data.key;
      const date = new Date(value);
      const mnth = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      const year = date.getFullYear();
      const formattedDate = [mnth, day, year].join('-');
      this.props.invoiceFiltersActions.setFilterValue(
        filterKey,
        filter.data.type,
        formattedDate
      );
      const areFiltersValid = this.props.invoiceFiltersActions.validateDateFilters(
        filter.title
      );
      this.setState({ disableApplyButton: !areFiltersValid });
    } else {
      const filterKey = ev.target.name;
      this.props.invoiceFiltersActions.setFilterValue(
        filterKey,
        filter.data.type,
        value
      );
      if (filter.data.type === STRING) {
        this.setState({ disableApplyButton: false });
      }
    }
  };

  handleFieldBlur = filter => {
    const areFiltersValid = this.props.invoiceFiltersActions.validateFilter(
      filter
    );
    this.setState({ disableApplyButton: !areFiltersValid });
  };

  render() {
    const { title, open, baseWidth, tempFilters } = this.props;
    return (
      <SovosReadOnlySlidingPanel
        title={ title }
        open={ open }
        onClose={ this.handleCloseSlidingPanel }
        baseWidth={ baseWidth }
        additionalButtons={ [
          <SovosButtonsGroup
            key="filter-additional-action-buttons"
            align="center"
            className="filter-additional-action-button"
          >
            <SovosRaisedButton
              key="apply-button"
              color={ white }
              backgroundColor={ purpleDecorations }
              onClick={ this.handleApplyClick }
              disabled={ this.state.disableApplyButton }
            >
              APPLY
            </SovosRaisedButton>
            <SovosRaisedButton
              key="cancel-button"
              color={ purpleDecorations }
              backgroundColor={ white }
              onClick={ this.handleClearClick }
            >
              CLEAR
            </SovosRaisedButton>
          </SovosButtonsGroup>
        ] }
      >
        {tempFilters.map(filter => (
          <FilterItem
            key={ filter.data.key || filter.data.min.key }
            filter={ filter }
            onCollapse={ () => this.handleCollapseClick(filter) }
            onExpand={ () => this.handleExpandClick(filter) }
            onFieldChange={ (ev, value) =>
              this.handleFieldChange(ev, value, filter)
            }
            onFieldBlur={ () => this.handleFieldBlur(filter) }
          />
        ))}
      </SovosReadOnlySlidingPanel>
    );
  }
}

InvoiceFilterSlidingPanel.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  baseWidth: PropTypes.string,
  title: PropTypes.string.isRequired,
  tempFilters: PropTypes.array.isRequired,
  invoiceFiltersActions: PropTypes.shape({
    applyFilters: PropTypes.func,
    expandInvoiceFilter: PropTypes.func,
    clearInvoiceFilter: PropTypes.func,
    restoreInvoiceFilters: PropTypes.func,
    clearAllInvoiceFilters: PropTypes.func,
    setFilterValue: PropTypes.func,
    validateFilter: PropTypes.func,
    validateDateFilters: PropTypes.func
  }).isRequired
};

export default InvoiceFilterSlidingPanel;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceFilters/InvoiceFiltersSlidingPanel.js